import { COLORS, MAP_LAYER_IDS, SIDEBAR_VIEWS, SIDEBAR_SAVED_TABS } from '../../../../lib/constants';
import { getFeatureDisplayString } from '../../../../lib/features';
import { toTitleCase } from '../../../../lib/utils'
import { uploadPhoto } from '../../../../services/udapi/photos';
import AddFeatureToCollectionModal from '../../../Modals/AddFeatureToCollectionModal';
import Alert from '../../../Modals/Alert';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import Button from '../../../Button';
import Check from '../../../../assets/svg/Feather/Check';
import ghAnalytics from '../../../../lib/analytics';
import Trash2 from '../../../../assets/svg/Feather/Trash2';

export default (dispatch) => {
  const deleteFeature = (feature, previousView) => () => {
    const label = getFeatureDisplayString(feature.properties.ghType);
    dispatch({
      type: 'modals/close',
    });

    dispatch({
      type: 'toast/show',
      payload: {
        text: `Deleting ${label}...`,
        loader: true,
      },
    });
    dispatch({
      type: 'features/setFeaturesLoading',
      payload: true,
    });
    dispatch({
      type: 'features/deleteFeatureEffect',
      payload: feature.uuid,
      callback: (response) => {
        if (!response) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: `There was an issue and your ${label} was not deleted.`,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true,
            },
          });
        } else {
          if (previousView) {
            dispatch({
              type: 'app/gotoSidebar',
              payload: previousView,
            });
          } else {
            dispatch({
              type: 'app/gotoSidebar',
              payload: SIDEBAR_VIEWS.Content,
            });
          }
          dispatch({
            type: 'features/setFeaturesLoading',
            payload: false,
          });
          dispatch({
            type: 'toast/show',
            payload: {
              text: `${label} Deleted`,
              icon: Trash2,
            },
          });
          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss',
            });
          }, 3500);

          ghAnalytics.logDeleteFeature(feature);
        }
      },
    });
  };

  const addFeatureToCollections = (collections, selectedFeatures) => {
    const collectionIds = collections.map((collection) => collection.uuid);
    const selectedFeature = selectedFeatures[0];
    const newCollectionIdsList = [
      ...selectedFeature.collectionIds,
      ...collectionIds,
    ];

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Adding feature to hunts...',
        loader: true,
      },
    });

    dispatch({
      type: 'modals/close',
    });

    dispatch({
      type: 'features/addFeatureToCollectionsEffect',
      payload: collectionIds,
      callback: (response) => {
        if (!response) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'An error occurred when adding your feature to hunt',
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        } else if (response.data.failed.collections.length) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'An error occurred when adding your feature to hunt',
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        } else if (response.data.successful.collections.length > 0) {
          ghAnalytics.logCollectionItemAdded(collections, selectedFeature);

          dispatch({
            type: 'features/updateSelectedFeature',
            payload: {
              ...selectedFeature,
              collectionIds: newCollectionIdsList,
            },
          });

          // dispatch({
          //   type: 'features/addFeatureToCollections',
          //   payload: {
          //     featureId: selectedFeature.uuid,
          //     collectionIds: collectionIds,
          //   },
          // });

          dispatch({
            type: 'collections/addFeatureToCollectionsList',
            payload: {
              featureId: selectedFeature.uuid,
              collectionIds: collectionIds,
            },
          });

          dispatch({
            type: 'toast/show',
            payload: {
              text: 'Feature added to hunts',
              icon: Check,
              iconColor: '#f37735',
            },
          });

          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss',
            });
          }, 3500);
        }
      },
    });
  };

  const storePhoto = (file, photoId, feature) => {
    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Uploading photo...',
        loader: true,
        dismissable: true,
      },
    });

    dispatch({
      type: 'features/setIsUploadingPhoto',
      payload: true,
    });

    uploadPhoto(file, feature.uuid, photoId)
      .then((result) => {
        if (result.success) {
          dispatch({
            type: 'features/getPhotoPoll-start',
            payload: photoId,
            callback: (response) => {
              if (response) {
                dispatch({
                  type: 'features/getPhotoPoll-stop',
                });

                dispatch({
                  type: 'features/addPhotoToSelectedFeature',
                  payload: response.data,
                });

                dispatch({
                  type: 'features/setIsUploadingPhoto',
                  payload: false,
                });

                dispatch({
                  type: 'toast/show',
                  payload: {
                    text: 'Photo uploaded',
                    icon: Check,
                    iconColor: '#F37735',
                  },
                });

                setTimeout(() => {
                  dispatch({
                    type: 'toast/dismiss',
                  });
                }, 3500);

                ghAnalytics.logUploadPhoto(photoId);
              } else {
                dispatch({
                  type: 'toast/show',
                  payload: {
                    dismissable: true,
                    icon: AlertCircle,
                    iconColor: '#FF3B30',
                    text: 'There was an error retrieving your photo.',
                  },
                });

                dispatch({
                  type: 'features/setIsUploadingPhoto',
                  payload: false,
                });
              }
            },
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: {
              dismissable: true,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              text: 'There was an error uploading your photo.',
            },
          });

          dispatch({
            type: 'features/setIsUploadingPhoto',
            payload: false,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: 'toast/show',
          payload: {
            dismissable: true,
            icon: AlertCircle,
            iconColor: '#FF3B30',
            text: 'There was an error uploading your photo.',
          },
        });

        dispatch({
          type: 'features/setIsUploadingPhoto',
          payload: false,
        });
      });
  };

  const leaveShare = (feature) => {
    dispatch({
      type: 'share/leaveShare',
      payload: {
        grantableType: 'features',
        grantableId: feature.uuid
      },
      callback: success => {
        if (success) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'You have succesfully left the shared feature.',
              icon: Check,
              iconColor: COLORS.ghOrange
            }
          });
      
          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss'
            });
          }, 3500);
      
          dispatch({
            type: 'map/removeGraphicByFeatureId',
            payload: {
              featureId: feature.uuid,
              layerId: MAP_LAYER_IDS.content
            }
          });
    
          dispatch({
            type: 'features/deleteFeatureFromUserData',
            payload: feature.uuid
          });

          dispatch({
            type: 'collections/removeFeatureFromCollections',
            payload: {
              collectionIds: feature.collectionIds,
              featureId: feature.uuid
            },
            callback: () =>
              dispatch({
                type: 'collections/setCollectionsLoading',
                payload: false,
              }),
          });
      
          dispatch({
            type: 'app/gotoSidebar',
            payload: {
              view: SIDEBAR_VIEWS.Content,
              metadata: {
                tab: SIDEBAR_SAVED_TABS.Content,
              },
            },
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue leaving the shared feature.',
              icon: AlertCircle,
              iconColor: COLORS.errorRed,
              dismissable: true
            }
          });
        }
      }
    });
  };

  return {
    toggleEditFeature: () => {
      dispatch({ type: 'features/toggleEditingFeature' });
      dispatch({
        type: 'app/gotoSidebarWithHistory',
        payload: SIDEBAR_VIEWS.FeatureEditor,
      });
    },
    showAddToCollectionModal: (feature) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: AddFeatureToCollectionModal,
          props: {
            selectedFeatures: [{ ...feature }],
            onAdd: addFeatureToCollections,
            onClose: () => {
              dispatch({ type: 'modals/close' });
            },
          },
        },
      });
    },
    goToCenter: (feature) => {
      dispatch({
        type: 'map/goToFeature',
        payload: {
          featureId: feature.uuid,
          layerId: MAP_LAYER_IDS.content,
        },
      });
    },
    showDeleteModal: (feature, previousView) => {
      const label = getFeatureDisplayString(feature.properties.ghType);

      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: `Delete ${toTitleCase(label)}?`,
            subtitle: `Are you sure you want to delete this ${toTitleCase(label)}? You will lose all notes and photos associated with it.`,
            actionItems: [
              {
                title: 'Delete',
                onClick: deleteFeature(feature, previousView),
              },
              {
                title: 'Cancel',
                theme: Button.THEME.solidSecondary,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    },
    processPhoto: (files, feature) => {
      for (let file of files) {
        dispatch({
          type: 'features/getNewPhotoIdEffect',
          payload: file.name,
          callback: (photoId) => {
            const reader = new FileReader();
            reader.onload = () => {
              storePhoto(file, photoId, feature);
            };
            reader.readAsDataURL(file);
          },
        });
      }
    },
    showLeftShare: (feature) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: 'Leave feature?',
            actionItems: [
              {
                title: 'Leave',
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                  leaveShare(feature);
                },
              },
              {
                title: 'Cancel',
                theme: Button.THEME.white,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    }
  };
};
